"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingProduct = exports.ShoppingCarousel = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var _chevron = _interopRequireDefault(require("./chevron.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PrevArrow = function PrevArrow(props) {
  var onClick = props.onClick;
  return _react.default.createElement(_styles.NextArrowEl, {
    onClick: onClick
  }, _react.default.createElement("img", {
    src: _chevron.default,
    alt: "Chevron"
  }));
};

var NextArrow = function NextArrow(props) {
  var onClick = props.onClick;
  return _react.default.createElement(_styles.PrevArrowEl, {
    onClick: onClick
  }, _react.default.createElement("img", {
    src: _chevron.default,
    alt: "Chevron"
  }));
};

var ShoppingProduct = function ShoppingProduct(props) {
  var image = props.image,
      name = props.name,
      brand = props.brand,
      price = props.price,
      url = props.url;
  var fluid = image && image.fluid || image;

  function content() {
    return _react.default.createElement(_styles.SliderItem, null, _react.default.createElement(_styles.ImageWrapper, null, _react.default.createElement(_styles.Image, {
      src: fluid === null || fluid === void 0 ? void 0 : fluid.src
    })), _react.default.createElement(_styles.TextWrapper, null, _react.default.createElement(_styles.Text, null, "".concat(brand, " - ").concat(name)), price && _react.default.createElement(_styles.Price, null, price)));
  }

  function showContent() {
    if (url) {
      return _react.default.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noreferrer"
      }, content());
    } else {
      return content();
    }
  }

  return _react.default.createElement(_styles.Container, null, showContent());
};

exports.ShoppingProduct = ShoppingProduct;

var ShoppingCarousel = function ShoppingCarousel(_ref) {
  var shoppingProducts = _ref.shoppingProducts;
  var defaultSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: shoppingProducts.length >= 3 ? 3 : 2,
    slidesToScroll: shoppingProducts.length >= 3 ? 3 : 2,
    touchThreshold: 13,
    centerPadding: 0,
    autoplay: false,
    prevArrow: _react.default.createElement(PrevArrow, null),
    nextArrow: _react.default.createElement(NextArrow, null)
  };

  function formatPrice(price) {
    if (price) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(price);
    }

    return '';
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.SliderContainer, null, _react.default.createElement(_reactSlick.default, defaultSettings, shoppingProducts.map(function (shoppingProduct, index) {
    return _react.default.createElement(ShoppingProduct, {
      key: "shopping-product--".concat(index),
      url: shoppingProduct.url,
      image: shoppingProduct.image,
      price: formatPrice(shoppingProduct.price),
      name: shoppingProduct.name,
      brand: shoppingProduct.brand
    });
  })))));
};

exports.ShoppingCarousel = ShoppingCarousel;